import Step from './DashboardBuilderStep'
import { useAct } from 'DashboardBuilder/store'
import DashboardFieldEditor from './DashboardFields/DashboardFieldEditor'
import dashboardFields from 'DashboardBuilder/store/dashboardFields'
import validate from 'Shared/ScriptEditor/functions/validate'

function ShortDescriptor() {
  const fieldCount = useSel(s => _.values(s.dashboardFields.entities).filter(f => f.active).length)
  const complete = fieldCount > 0

  if (!complete){
    return <p className='incomplete no-margin-bottom'>Add columns to the dashboard</p>
  } else {
    return <p className='complete no-margin-bottom'>{fieldCount} {fieldCount === 1 ? 'column' : 'columns'} added</p>
  }
}

export default function DashboardFields() {
  const act = useAct()
  const fieldCount = useSel(s => _.values(s.dashboardFields.entities).filter(f => f.active).length)
  const invalidFields = useSel(s => dashboardFields.selectInvalidDashboardFields(s))

  const dashboardFieldsEntities = useSel(s => s.dashboardFields.entities)
  const questionsEntities = useSel(s => s.questions?.entities || {})
  const answersEntities = useSel(s => s.answers?.entities || {})

  const { questions, answers } = useMemo(() => {
    const activeFields = _.values(dashboardFieldsEntities).filter(f => f.active && f.questionId)
    const questionIds = activeFields.map(f => f.questionId)
    const filteredQuestions = _.values(questionsEntities).filter(q => questionIds.includes(q.id))
    const filteredAnswers = _.values(answersEntities).filter(a => questionIds.includes(a.questionId))

    return {
      questions: filteredQuestions,
      answers: filteredAnswers
    }
  }, [dashboardFieldsEntities, questionsEntities, answersEntities])

  const [questionValidationErrors, setQuestionValidationErrors] = useState([])

  useEffect(() => {
    if (questions.length > 0) {
      validate(questions, answers, setQuestionValidationErrors)
    } else {
      setQuestionValidationErrors([])
    }
  }, [questions, answers])

  const complete = fieldCount > 0
  const canFinish = invalidFields.length === 0 && questionValidationErrors.length === 0

  function save() {
    return act.builder.save('dashboardFields').then(() => {
      act.builder.closeEditor()
    })
  }

  return (
    <Step
      name="Dashboard Columns"
      editor="dashboardFields"
      editable={true}
      complete={complete}
      save={save}
      canClickFinish={canFinish}
      validationErrors={questionValidationErrors}
      shortDescriptor={<ShortDescriptor />}>
      <DashboardFieldEditor />
    </Step>
  )
}
